import {
  ApiGeoCoordinatesAdapter,
  LocationType,
  apiAdaptOrNull,
} from '@fmnts/api/shared';
import { Adapter } from '@fmnts/core';
import { IApiNextLocation } from '../api-model/api-model';
import { NextLocation } from '../model/next-location';

export class ApiNextLocationAdapter implements Adapter<NextLocation> {
  private readonly _coordinatesAdapter = new ApiGeoCoordinatesAdapter();

  adapt(item: IApiNextLocation): NextLocation {
    return {
      capacity: item.capacity,
      city: item.city,
      code: item.code,
      coordinates: apiAdaptOrNull.adaptOrNull(
        item.coordinates,
        this._coordinatesAdapter,
      ),
      id: item.id,
      isBoothRequired: item.is_booth_required,
      isRainProof: item.is_rain_proof,
      name: item.name,
      permitUrl: item.permit_url,
      streetAddress: item.street_address,
      thumbnailUrl: item.thumbnail_url,
      type: item.type as LocationType,
    };
  }
}
